import { toObservable } from '@angular/core/rxjs-interop';

import { lastValueFrom } from 'rxjs';

import { map, switchMap } from 'rxjs/operators';

import { Signal, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import {
  EntityWithApproveConstraint,
  GridQueryParams,
  defaultParamsSignal,
  mapPageWithDraftsResponseToPageWithDrafts,
  mapSuccessQueryToGridResultWithDrafts,
  pagedWithDraftsEntityCollectionMutations,
} from '@/common';
import { normalizeGridQueryParams } from '@/common/grid-helpers';
import { PageWithDraftsResponse } from '@/api/types';

import { injectPersistedQuery } from './inject-persisted-query';

export function injectDraftedCollection<Entity extends EntityWithApproveConstraint>(
  baseUrl: string,
  baseKey: unknown[],
  paramsSignal?: Signal<GridQueryParams>
) {
  const http = inject(HttpClient);

  const params = paramsSignal ?? defaultParamsSignal();
  const params$ = toObservable(normalizeGridQueryParams(params));

  const mutations = pagedWithDraftsEntityCollectionMutations<Entity>(baseKey, baseUrl, params);

  const persistedQuery = injectPersistedQuery<PageWithDraftsResponse<Entity>>(baseUrl);

  const result$ = params$.pipe(
    switchMap(params =>
      persistedQuery([...baseKey, params], params).result$.pipe(
        map(mapPageWithDraftsResponseToPageWithDrafts()),
        map(mapSuccessQueryToGridResultWithDrafts(r => r))
      )
    )
  );

  const getAll = () =>
    lastValueFrom(
      http.get<Entity[]>(baseUrl + 'all', {
        params: {
          params: JSON.stringify(params()),
        },
      })
    );

  return {
    mutations,
    result$,
    getAll,
  };
}
